export default __webpack_public_path__ + "static/media/1d3191cd-ae8c-45e2-bb04-11e96d8fa974.1cae0807.woff2";